import { gql } from '@apollo/client';

// ============================================================================
// Queries
// ============================================================================

/**
 * Aktuelle Benachrichtigungs-Einstellungen des eingeloggten Users
 * (Frequenz, überwachte Belegtypen, Onboarding-/Admin-Status).
 */
export const NOTIFICATION_PREFS_QUERY = gql`
  query NotificationPrefs {
    notificationPrefs {
      frequency
      docTypes
      onboardingDone
      disabledForAdmin
    }
  }
`;

// ============================================================================
// Mutations
// ============================================================================

/**
 * Setzt Frequenz + überwachte Belegtypen. Gibt die aktualisierten Prefs
 * zurück (Aufrufer sollten zusätzlich NOTIFICATION_PREFS_QUERY refetchen,
 * falls der Cache nicht automatisch normalisiert wird).
 */
export const SET_NOTIFICATION_PREFS_MUTATION = gql`
  mutation SetNotificationPrefs($frequency: NotificationFrequency!, $docTypes: [DocumentType!]!) {
    setNotificationPrefs(frequency: $frequency, docTypes: $docTypes) {
      frequency
      docTypes
      onboardingDone
      disabledForAdmin
    }
  }
`;
